import { DOCUMENT, DestroyRef, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { APP_CONFIG } from '../../../core/config/app-config.token';
import { AccessibilityStore } from '../state/accessibility.store';

const HOME_PATH = '/';

const ACTIVITY_EVENTS = ['pointerdown', 'pointermove', 'wheel', 'keydown'] as const;

@Injectable({ providedIn: 'root' })
export class IdleWatch {
  private readonly document = inject(DOCUMENT);
  private readonly router = inject(Router);
  private readonly accessibility = inject(AccessibilityStore);
  private readonly destroyRef = inject(DestroyRef);
  private readonly resetMs = inject(APP_CONFIG).totem.idleResetMs;
  private readonly postpone = (): void => this.schedule();

  private countdown: ReturnType<typeof setTimeout> | null = null;

  start(): void {
    for (const event of ACTIVITY_EVENTS) {
      this.document.addEventListener(event, this.postpone, { passive: true, capture: true });
    }

    this.destroyRef.onDestroy(() => this.stop());
    this.schedule();
  }

  private stop(): void {
    for (const event of ACTIVITY_EVENTS) {
      this.document.removeEventListener(event, this.postpone, { capture: true });
    }

    this.clear();
  }

  private schedule(): void {
    this.clear();
    this.countdown = setTimeout(() => void this.returnHome(), this.resetMs);
  }

  private clear(): void {
    if (this.countdown !== null) {
      clearTimeout(this.countdown);
      this.countdown = null;
    }
  }

  private async returnHome(): Promise<void> {
    this.countdown = null;
    this.accessibility.reset();

    if (this.router.url !== HOME_PATH) {
      await this.router.navigate([HOME_PATH], { replaceUrl: true });
    }

    this.schedule();
  }
}
